import React from 'react';

import { Box } from '@mui/material';

import { CardInfoSection } from '../../components/CardInfoSection';
import { CardTransportSection } from '../../components/CardTransportSection';


export const SelectedSectionDetails = ({feature, typeAcc}) => {
  const style = {
    cardBase: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }
  };

  const renderCardSelectedSection = () => {
    if (feature && feature.properties.m === 'transit') {
      return (
        <CardTransportSection selectedTransport={feature} />
      );
    } else {
      return (
        <CardInfoSection selectedSection={feature} typeAcc={typeAcc} />
      );
    }
  };
  
  return (
    <Box sx={style.cardBase}>
      {renderCardSelectedSection()}
    </Box>
  );
};